var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6364 41.0526C11.4723 41.0526 0 46.7053 0 53.6842V60H51.2727V53.6842C51.2727 46.7053 39.8005 41.0526 25.6364 41.0526ZM12.8182 22.1053C12.8182 25.4554 14.1687 28.6683 16.5725 31.0371C18.9764 33.406 22.2368 34.7368 25.6364 34.7368C29.036 34.7368 32.2963 33.406 34.7002 31.0371C37.1041 28.6683 38.4545 25.4554 38.4545 22.1053M24.0341 0C23.0727 0 22.4318 0.663158 22.4318 1.57895V11.0526H19.2273V3.15789C19.2273 3.15789 12.017 5.87368 12.017 15C12.017 15 9.61364 15.4421 9.61364 18.9474H41.6591C41.4989 15.4421 39.2557 15 39.2557 15C39.2557 5.87368 32.0455 3.15789 32.0455 3.15789V11.0526H28.8409V1.57895C28.8409 0.663158 28.232 0 27.2386 0H24.0341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialist);
export default __webpack_public_path__ + "static/media/specialist.bcd2bd8972e9fbd5a00b62c2959bfc2d.svg";
export { ForwardRef as ReactComponent };